import React from 'react'
import { useSelector } from 'react-redux';
import Navbar from '../components/Navbar'
import ProgressBar from '../components/ProgressBar'
import { CODEMP_CREDITO_ARGENTINO, CODEMP_MUSIMUNDO } from '../utilities';
import { Grid } from '@mui/material';


const Layout = ({ children }) => {

    const { globalTab, currentTab, firstStep, paramsMus } = useSelector((state) => state.firstStep);
    const { codemp } = useSelector(state => state.adminReducer.login);


    return (
        <Grid container display={'flex'} justifyContent={'center'} >
            <Grid item xs={12} justifyContent={'center'} height={"60px"} >
                <Navbar /*handleTabClick={handleTabClick}*/ activeTab={currentTab} codpmpol={paramsMus.nro} />
            </Grid>
            <div className="tab-content">
                {
                    currentTab === 1 &&
                    (<div className='textHeader'>
                        <h3 style={{ fontSize: '1.8rem' }}>Elegí </h3>
                        <h3 style={{ marginBottom: '10px', fontSize: '1.8rem' }}>entre los planes</h3>
                        <p style={{ fontSize: '1rem' }}>Seleccioná el plan que más se adapte a </p>
                        <p style={{ fontSize: '1rem' }}>tus necesidades y preferencias.</p>
                    </div>)
                }
                {
                    (currentTab === 2) &&
                    (
                        globalTab === 2.0 ?
                            (<div className='textHeader'>
                                <h3 style={{ fontSize: '1.8rem' }}>Preguntas frecuentes</h3>
                            </div>)
                            :
                            globalTab === 2.3 ?
                                (<div className='textHeader'>
                                    <h3 style={{ fontSize: '1.8rem' }}>Elegí </h3>
                                    <h3 style={{ marginBottom: '10px', fontSize: '1.8rem' }}>a tus beneficiarios</h3>
                                    <p>Seleccioná entre las opciones a la persona o las personas que quieras asegurar.</p>
                                </div>)
                                :
                                globalTab === 2.5 ?
                                    (<div className='textHeader'>
                                        <h3 style={{ fontSize: '1.8rem' }}>Completá</h3>
                                        <h3 style={{ fontSize: '1.8rem' }}>los datos de tu hogar</h3>
                                        <p style={{ fontSize: '1rem' }}>Necesitamos más detalles de tu casa para asegurar todos los rincones de tu hogar.</p>
                                    </div>)
                                    :
                                    globalTab === 2.6 ?
                                        firstStep.codsec === '12' ?
                                            (<div className='textHeader'>
                                                <h3 style={{ fontSize: '1.8rem' }}>Agregá a</h3>
                                                <h3 style={{ marginBottom: '10px' }}>tus beneficiarios</h3>
                                                <p style={{ fontSize: '1rem' }}>Necesitamos registrar los datos de los beneficiarios para realizar la póliza.</p>
                                            </div>)
                                            :
                                            firstStep.codsec === '159' ?
                                                (<div className='textHeader'>
                                                    <h3 style={{ fontSize: '1.8rem' }}>Agregá</h3>
                                                    <h3 style={{ marginBottom: '10px' }}>el detalle de tu notebook</h3>
                                                    <p style={{ fontSize: '1rem' }}>Necesitamos registrar los datos para realizar la póliza.</p>
                                                </div>)
                                                :
                                                (<div className='textHeader'>
                                                    <h3 style={{ fontSize: '1.8rem' }}>Agregá al</h3>
                                                    <h3 style={{ marginBottom: '10px' }}>usuario del producto a riesgo</h3>
                                                    <p style={{ fontSize: '1rem' }}>Necesitamos registrar los datos para realizar la póliza.</p>
                                                </div>)
                                        :
                                        (<div className='textHeader'>
                                            <h3 style={{ marginTop: 1, fontSize: '1.8rem' }}>Completá</h3>
                                            <h3 style={{ marginTop: 1, marginBottom: '10px', fontSize: '1.8rem' }}>con tus datos</h3>
                                            <p style={{ marginTop: 1, fontSize: '1rem' }}>Tu información servirá para poder  </p>
                                            <p style={{ fontSize: '1rem' }}>realizar la documentación de tu seguro.</p>
                                        </div>)
                    )
                }
                {
                    currentTab === 3 &&
                    (<div className='textHeader'>
                        <h3 style={{ fontSize: '1.8rem' }}>Pagá</h3>
                        <h3 style={{ marginBottom: '10px', fontSize: '1.8rem' }} >de manera fácil</h3>
                        <p style={{ fontSize: '1rem' }}>Elegí un medio de pago y obtené tu seguro al instante.</p>
                    </div>)
                }

                {
                    globalTab !== 2.0 &&
                    < div className="tabs">
                        <div className='progressBar'>
                            <ProgressBar activeTab={currentTab} firstStep={firstStep} />

                            <div className="tabs_uno">
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%', paddingLeft: "12px", paddingRight: "12px" }}>
                                    <div
                                        style={{ display: 'flex', paddingLeft: '6px', fontSize: '0.688rem' }}
                                        className={`tab ${(currentTab === 1 && CODEMP_CREDITO_ARGENTINO.includes(codemp)) ? 'active-cfn' : (currentTab === 1 && CODEMP_MUSIMUNDO.includes(codemp)) ? 'active' : ''}`}
                                    >
                                        Elegí
                                    </div>
                                    <div style={{ fontSize: '0.688rem' }}
                                        className={`tab ${(currentTab === 2 && CODEMP_CREDITO_ARGENTINO.includes(codemp)) ? 'active-cfn' : (currentTab === 2 && CODEMP_MUSIMUNDO.includes(codemp)) ? 'active' : ''}`}
                                    >
                                        Completá
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingRight: '6px', fontSize: '0.688rem' }}
                                        className={`tab ${(currentTab === 3 && CODEMP_CREDITO_ARGENTINO.includes(codemp)) ? 'active-cfn' : (currentTab === 3 && CODEMP_MUSIMUNDO.includes(codemp)) ? 'active' : ''}`}
                                    >
                                        Contratá
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                {children}
            </div>
        </Grid >
    )
};


export default Layout;


//     return (
//         <Container className='landScape' style={{ paddingLeft: 6, paddingRight: 6 }}>

//             <Navbar /*handleTabClick={handleTabClick}*/ activeTab={currentTab} codpmpol={paramsMus.nro} />

//             <div className="tab-content">
//                 {
//                     currentTab === 1 &&
//                     (<div className='textHeader'>
//                         <h3 style={{ fontSize: '1.8rem' }}>Elegí </h3>
//                         <h3 style={{ marginBottom: '10px', fontSize: '1.8rem' }}>entre los planes</h3>
//                         <p style={{ fontSize: '1rem' }}>Seleccioná el plan que más se adapte a </p>
//                         <p style={{ fontSize: '1rem' }}>tus necesidades y preferencias.</p>
//                     </div>)
//                 }
//                 {
//                     (currentTab === 2) &&
//                     (
//                         globalTab === 2.0 ?
//                             (<div className='textHeader'>
//                                 <h3 style={{ fontSize: '1.8rem' }}>Preguntas frecuentes</h3>
//                             </div>)
//                             :
//                             globalTab === 2.3 ?
//                                 (<div className='textHeader'>
//                                     <h3 style={{ fontSize: '1.8rem' }}>Elegí </h3>
//                                     <h3 style={{ marginBottom: '10px', fontSize: '1.8rem' }}>a tus beneficiarios</h3>
//                                     <p>Seleccioná entre las opciones a la persona o las personas que quieras asegurar.</p>
//                                 </div>)
//                                 :
//                                 globalTab === 2.5 ?
//                                     (<div className='textHeader'>
//                                         <h3 style={{ fontSize: '1.8rem' }}>Completá</h3>
//                                         <h3 style={{ fontSize: '1.8rem' }}>los datos de tu hogar</h3>
//                                         <p style={{ fontSize: '1rem' }}>Necesitamos más detalles de tu casa para asegurar todos los rincones de tu hogar.</p>
//                                     </div>)
//                                     :
//                                     globalTab === 2.6 ?
//                                         firstStep.codsec === '12' ?
//                                             (<div className='textHeader'>
//                                                 <h3 style={{ fontSize: '1.8rem' }}>Agregá a</h3>
//                                                 <h3 style={{ marginBottom: '10px' }}>tus beneficiarios</h3>
//                                                 <p style={{ fontSize: '1rem' }}>Necesitamos registrar los datos de los beneficiarios para realizar la póliza.</p>
//                                             </div>)
//                                             :
//                                             firstStep.codsec === '159' ?
//                                                 (<div className='textHeader'>
//                                                     <h3 style={{ fontSize: '1.8rem' }}>Agregá</h3>
//                                                     <h3 style={{ marginBottom: '10px' }}>el detalle de tu notebook</h3>
//                                                     <p style={{ fontSize: '1rem' }}>Necesitamos registrar los datos para realizar la póliza.</p>
//                                                 </div>)
//                                                 :
//                                                 (<div className='textHeader'>
//                                                     <h3 style={{ fontSize: '1.8rem' }}>Agregá al</h3>
//                                                     <h3 style={{ marginBottom: '10px' }}>usuario del producto a riesgo</h3>
//                                                     <p style={{ fontSize: '1rem' }}>Necesitamos registrar los datos para realizar la póliza.</p>
//                                                 </div>)
//                                         :
//                                         (<div className='textHeader'>
//                                             <h3 style={{ marginTop: 1, fontSize: '1.8rem' }}>Completá</h3>
//                                             <h3 style={{ marginTop: 1, marginBottom: '10px', fontSize: '1.8rem' }}>con tus datos</h3>
//                                             <p style={{ marginTop: 1, fontSize: '1rem' }}>Tu información servirá para poder  </p>
//                                             <p style={{ fontSize: '1rem' }}>realizar la documentación de tu seguro.</p>
//                                         </div>)
//                     )
//                 }
//                 {
//                     currentTab === 3 &&
//                     (<div className='textHeader'>
//                         <h3 style={{ fontSize: '1.8rem' }}>Pagá</h3>
//                         <h3 style={{ marginBottom: '10px', fontSize: '1.8rem' }} >de manera fácil</h3>
//                         <p style={{ fontSize: '1rem' }}>Elegí un medio de pago y obtené tu seguro al instante.</p>
//                     </div>)
//                 }

//                 {
//                     globalTab !== 2.0 &&
//                     < div className="tabs">
//                         <div className='progressBar'>
//                             <ProgressBar activeTab={currentTab} firstStep={firstStep} />

//                             <div className="tabs_uno">
//                                 <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%' }}>
//                                     <div style={{ display: 'flex', paddingLeft: '6px', fontSize: '0.688rem' }} className={`tab ${currentTab === 1 ? 'active' : ''}`}
//                                     >
//                                         Elegí
//                                     </div>
//                                     <div style={{ fontSize: '0.688rem' }}
//                                         className={`tab ${currentTab === 2 ? 'active' : ''}`}
//                                     >
//                                         Completá
//                                     </div>
//                                     <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingRight: '6px', fontSize: '0.688rem' }}
//                                         className={`tab ${currentTab === 3 ? 'active' : ''}`}
//                                     >
//                                         Contratá
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>}
//                 {children}
//             </div>
//         </Container >
//     )
// };


